import React from "react";
import BusinessCard from "../../../Shared/BusinessCenter/components/BusinessCard";
import PointPlan from "./PointPlan";
import { IoWifi } from "react-icons/io5";
import { IoMdTv } from "react-icons/io";
import { FaPhone } from "react-icons/fa6";
import ContactButtons from "../../../../Services/ContactButtons";
import MobileVersionBusinessCard from "../../../Reps/DigitalBusinessCenter/components/MobileVersionBusinessCard";
import PlanCard from "./PlanCard";
import { FaCheckCircle } from "react-icons/fa";
const Index = ({
	offer,
	setOpenConsultation,
	setOpenShareModal,
	setColor,
	setOpen,
	setSelectedPlan,
}) => {
	const neverPromo = [
		"SYMMETRICAL SPEEDS",
		"NO DATA CAPS - UNLIMITED",
		"NO CONTRACTS REQUIRED",
		"NO HIDDEN FEES",
		"NO SURPRISES",
		"YOUR CHOICE OF ONE:",
		"30-DAY MONEY-BACK ;GUARANTEE—RISK-FREE ",
		"SATISFACTION",
		"$5/MO DISCOUNT ;FOR 12 MONTHS",
		"MODEM INCLUDED ;(NO EXPIRATION)",
		// "ROUTER AVAILABLE ;FOR $5/MO OR USE YOUR OWN",
		"FREE INSTALLATION",
	];
	const hfcNotNeverPromo = [
		"NO DATA CAPS - UNLIMITED",
		"NO CONTRACTS REQUIRED",
		"NO HIDDEN FEES OR SURPRISES",
		"$100 GIFT CARD",
		"$5/MO DISCOUNT ;FOR 12 MONTHS",
		"WAIVE ALL EQUIPMENT FEES ; MODEM & ROUTER INCLUDED! ; ($120 ANNUAL VALUE)",
		"1ST MONTH FREE",
		"FREE INSTALL ($99.95 VALUE)",
	];
	const notNeverPromo = [
		"SYMMETRICAL SPEEDS",
		"NO DATA CAPS",
		"NO CONTRACTS",
		"NO HIDDEN FEES",
		"$100 GIFT CARD",
		"$5/MO DISCOUNT FOR 1 YEAR ;($60 VALUE)",
		"WAIVE ALL EQUIPMENT FEES ; MODEM & ROUTER INCLUDED! ; ($120 ANNUAL VALUE)",
		"1ST MONTH FREE",
		"FREE INSTALL ($99.95 VALUE)",
	];

	return (
		<div>
			<div
				style={{
					background: "none",
					backgroundColor: "white",
				}}
				className="bg-white new_offer_page"
			>
				<div
					style={{
						maxWidth: "800px",
					}}
					className="inner_container"
				>
					<div className="banner">
						<img
							style={{ width: "100%", height: "auto" }}
							src={`/images/offer/astound/astound_banner.png`}
							alt="banner"
							className="banner_image first"
						/>
						<div className="top_accept_offer">
							<div className="inner_div shadow-xl">
								<img
									style={{ width: "250px" }}
									src={"data:image/png;base64," + offer?.fiberCompany?.logo}
									alt="logo"
									className="logo"
								/>
								{offer?.lead?.leadType === "HFC" ? (
									offer.neverPromo ? (
										<div className="text-center flex flex-col gap-4">
											<h1 className="text-4xl font-[800] text-center text-black">
												FIBER INTERNET
												<br />
												NEW CUSTOMER
												<br />
												BEST DEAL EVER
											</h1>
											<p className="text-5xl font-[800]  text-[#483092] text-center">
												SAVE OVER
											</p>
											<p className="text-7xl font-[800]  text-[#3AB54A] text-center">
												$1,000
											</p>
											<p className="text-2xl font-[600]  text-black text-center">
												$30 Discount for 36 Months
											</p>
										</div>
									) : (
										<>
											<h1 className="text-[2.375rem] font-[800] text-center text-black">
												HYBRID-COAXIAL
												<br />
												FIBER INTERNET
											</h1>
											<h1 className="text-[2.375rem] mt-8 font-[800] text-center text-black">
												SPECIAL OFFER
											</h1>
										</>
									)
								) : offer.neverPromo ? (
									<div className="text-center flex flex-col gap-4">
										<h1 className="text-4xl font-[800] text-center text-black">
											FIBER INTERNET
											<br />
											NEW CUSTOMER
											<br />
											BEST DEAL EVER
										</h1>
										<p className="text-5xl font-[800]  text-[#483092] text-center">
											SAVE OVER
										</p>
										<p className="text-7xl font-[800]  text-[#3AB54A] text-center">
											$1,000
										</p>
										<p className="text-2xl font-[600]  text-black text-center">
											$30 Discount for 36 Months
										</p>
									</div>
								) : (
									<h1 className="text-[2.375rem] font-[800] text-center text-black">
										ULTRA-FAST,
										<br />
										RELIABLE
										<br />
										FIBER INTERNET
									</h1>
								)}

								<button
									className="text-white bg-gradient-to-r from-[#483092] via-[#019A86] to-[#C1DE2A] p-4 rounded-2xl text-center font-open-sans text-3xl font-extrabold uppercase "
									onClick={() => {
										document
											.getElementById("plan1")
											.scrollIntoView({ behavior: "smooth" });
									}}
								>
									VIEW PLANS{" "}
								</button>
							</div>
						</div>
					</div>
					<div className="company_details">
						{offer.neverPromo ? (
							<>
								<p className="sm:text-5xl font-[800] text-4xl text-black">
									EXCLUSIVE FIBER OFFER
								</p>
								<p className="sm:text-5xl font-[800] text-4xl text-black">
									FOR HOMES THAT
								</p>
								<p className="sm:text-7xl font-[800] text-6xl text-black">
									NEVER
								</p>
								<p className="sm:text-5xl font-[800] text-4xl text-black">
									HAD ASTOUND
								</p>
								<div className="promo_offer_border">
									<h1
										className="bg-white promo_offer"
										style={{ borderColor: "#30B151" }}
									>
										<h1 className="text-4xl font-[800] text-center text-black gap-4 flex justify-center items-center">
											<span
												style={{
													textTransform: "uppercase",
													fontSize: "1.5rem",
													fontWeight: "800",
													color: "white",
													backgroundColor: "#30B151",
													borderRadius: "20px",
													padding: "0.5rem 1rem",
													// display:"flex",
													// justifyContent:"center",
													// alignItems:"center",
													// width:"20%",
												}}
											>
												$30/mo
											</span>
											DISCOUNT
										</h1>
										<h1 className="text-4xl font-[800] text-center text-black mt-4">
											FOR 36 MONTHS
										</h1>
									</h1>
								</div>
								<h1 className="text-4xl font-[500] m-4 text-center text-black">
									-OR-
								</h1>
								<div className="promo_offer_border">
									<h1
										className="bg-white promo_offer"
										style={{ borderColor: "#483092" }}
									>
										<h1 className="text-4xl font-[800] text-center text-black gap-4 flex justify-center items-center">
											A
											<span
												style={{
													textTransform: "uppercase",
													fontSize: "1.5rem",
													fontWeight: "800",
													color: "white",
													backgroundColor: "#483092",
													borderRadius: "20px",
													padding: "0.5rem 1rem",
												}}
											>
												$400
											</span>
											GIFT CARD
										</h1>
									</h1>
								</div>
								<h1 className="text-5xl font-[800] mt-4 text-center text-[#3AB54A]">
									LIMITED TIME
								</h1>
								<h1 className="text-5xl font-[800] text-center text-black flex gap-4 justify-center items-center">
									NEVER
									<span
										style={{
											textTransform: "uppercase",
											fontSize: "2.5rem",
											fontWeight: "800",
											color: "black",
										}}
									>
										PROMO W/
									</span>
								</h1>
								<h1 className="text-5xl font-[800] text-center text-black">
									FREE INSTALLATION
								</h1>
							</>
						) : (
							<>
								<h1 className="text-4xl font-[800] mt-4 text-center text-black">
									ASTOUND <br />
									HYBRID FIBER-COAXIAL <br />
									TECHNOLOGY
									<br />
									YOU CAN TRUST
								</h1>
								<p className="sm:text-5xl font-[800] text-4xl text-black">
									LIMITED TIME OFFER
								</p>
								<p className="sm:text-5xl font-[800] text-4xl text-[#3AB54A]">
									FREE INSTALLATION &
								</p>
								<p className="sm:text-5xl font-[800] text-4xl text-[#483092]">
									1ST MONTH FREE!
								</p>
							</>
						)}
						{/* <div className="promo_offer_border">
							<h1
								className="bg-white promo_offer"
								style={{ borderColor: "#483092" }}
							>
								<span
									style={{
										textTransform: "uppercase",
										fontSize: "2.5rem",
										fontWeight: "800",
										color: "#3AB54A",
									}}
								>
									1-YEAR WITH<br></br>
								</span>
								<span
									style={{
										textTransform: "uppercase",
										fontSize: "2.5rem",
										fontWeight: "800",
										color: "#483092",
									}}
								>
									PRICES SHOWN
								</span>
							</h1>
						</div> */}
						<p className="available text-[#81848A]">AVAILABLE WITH</p>
						<img
							src={`/images/offer/astound/logo.png`}
							alt="astound"
							className="company_logo"
						/>
						<img
							src="/images/offer/logo.png"
							alt="lightning"
							className="company_logo"
						/>
					</div>
					{/* {offer?.salesRep && (
            <div
              style={{
                padding: "1rem",
                marginTop: "2rem",
                backgroundColor: "white",
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  padding: "1rem",
                  borderRadius: "10px",
                  color: "black",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <MobileVersionBusinessCard
                  displayContactButtons={true}
                  displayQr={false}
                  reviewButton={false}
                  displayOffer={false}
                  salesRep={offer?.salesRep}
                  salesRepIsUser={false}
                />
              </div>
            </div>
          )} */}
					{offer?.salesRep && (
						<div className="bg-white">
							<BusinessCard
								salesRep={offer?.salesRep}
								salesRepId={offer?.salesRepId}
								displayOffer={false}
								fiberCompany={offer?.fiberCompanyId}
							/>
						</div>
					)}

					<div className="banner" id="plan1">
						<img
							style={{ width: "100%", height: "auto" }}
							src="/images/offer/astound/friends_banner.png"
							alt="banner"
							className="banner_image"
						/>
						{/* <div className='flex justify-center items-center' style={{
                                backgroundColor: "#F47920",
                                marginTop: "-8rem",
                                padding: "5rem 1rem",

                                // borderRadius:"20px"
                            }}>
                                <PointPlan offer={offer} setColor={setColor} color={offer?.offerTemplate?.offerTemplateFiberPlans[0].color ? offer?.offerTemplate?.offerTemplateFiberPlans[1].color : "#01A7E1"} setSelectedPlan={setSelectedPlan} setOpen={setOpen} name={offer?.offerTemplate?.offerTemplateFiberPlans[1]?.promotionalName} plan={offer?.offerTemplate?.offerTemplateFiberPlans[0].fiberPlan} bulletPoints={offer?.offerTemplate?.bulletPoints} />
                            </div> */}
					</div>
					{offer?.offerTemplate && (
						<div className="company_details margin-top-4">
							<img
								style={{ width: "250px", margin: "3rem" }}
								src={"data:image/png;base64," + offer?.fiberCompany?.logo}
								alt="logo"
								className="logo"
							/>
							<PlanCard
								offer={offer}
								plan={
									offer?.offerTemplate?.offerTemplateFiberPlans[0]?.fiberPlan
								}
								color={
									offer?.offerTemplate?.offerTemplateFiberPlans[0]?.color
										? offer?.offerTemplate?.offerTemplateFiberPlans[0].color
										: "#483092"
								}
								setSelectedPlan={setSelectedPlan}
								setOpen={setOpen}
								name={
									offer?.offerTemplate?.offerTemplateFiberPlans[0]
										?.promotionalName
								}
							/>
							<PlanCard
								offer={offer}
								plan={
									offer?.offerTemplate?.offerTemplateFiberPlans[1]?.fiberPlan
								}
								color={
									offer?.offerTemplate?.offerTemplateFiberPlans[1]?.color
										? offer?.offerTemplate?.offerTemplateFiberPlans[1].color
										: "#206C8E"
								}
								setSelectedPlan={setSelectedPlan}
								setOpen={setOpen}
								name={
									offer?.offerTemplate?.offerTemplateFiberPlans[1]
										?.promotionalName
								}
							/>
							{offer?.offerTemplate?.offerTemplateFiberPlans?.length > 2 && (
								<PlanCard
									offer={offer}
									plan={
										offer?.offerTemplate?.offerTemplateFiberPlans[2]?.fiberPlan
									}
									color={
										offer?.offerTemplate?.offerTemplateFiberPlans[2]?.color
											? offer?.offerTemplate?.offerTemplateFiberPlans[2].color
											: "#30B151"
									}
									setSelectedPlan={setSelectedPlan}
									setOpen={setOpen}
									name={
										offer?.offerTemplate?.offerTemplateFiberPlans[2]
											?.promotionalName
									}
								/>
							)}
							<div className="company_details margin-top-4 text-black flex items-center justify-center ">
								{offer.neverPromo ? (
									<>
										<p className="max-w-lg flex flex-wrap text-xl text-center font-semibold px-10">
											^^Available in select areas.
										</p>
										<p className="max-w-lg flex flex-wrap text-xl text-center font-semibold p-10 pt-0" >
											***Price includes internet service and autopay/e-bill
											discount. $30 per month discount on Gig packages will be
											applied for 36 months. Excludes equipment, taxes,
											surcharges, and fees.
										</p>
										{offer?.neverPromo && (
											<li className="flex items-center mb-4 justify-center flex-wrap">
												<p className="text-[#2761D0] text-xl text-left font-bold underline">
													Terms & conditions may apply
												</p>
											</li>
										)}
									</>
								) : (
									<>
										<p className="max-w-lg flex flex-wrap text-xl text-center font-semibold px-10">
											^^Available in select areas.
										</p>
										<p className="max-w-lg flex flex-wrap text-xl text-center font-semibold p-10 pt-0">
											*Price includes internet service and autopay/e-bill
											discount. Excludes equipment, taxes, surcharges, and fees.
											Available in select areas.
										</p>
										</>
								)}
								<span className="text-black text-4xl font-bold text-center">
									NOW WITH <br />
									<h1 className="text-black text-5xl font-bold text-center">
										MORE VALUE
									</h1>
									THAN EVER
								</span>
							</div>
							{offer?.offerTemplate?.bulletPoints && (
								<div
									style={{
										marginTop: "2rem",
										padding: "0rem",
									}}
									className=" offer_services_container"
								>
									<div
										className="min-w-[350px] text-black inner_container"
										style={{
											border: "4px solid #483092",
											display: "flex",
											flexDirection: "column",
											padding: "1rem",
											gap: "2rem",
											maxWidth: "100vw",
										}}
									>
										<h1 className="text-[#483092]">What You Get</h1>
										<ul className="flex flex-col gap-4">
											{offer?.lead?.leadType === "HFC" ? (
												offer?.neverPromo ? (
													<>
														{" "}
														{neverPromo.map((item, index) => {
															if (index > 5) {
																return <></>;
															}
															const split = item.split(";");
															return (
																<li
																	className="flex items-center justify-start "
																	key={index}
																>
																	<div className="w-10">
																		<FaCheckCircle
																			color={"#3AB54A"}
																			size={25}
																		/>
																	</div>
																	<p className="text-black text-left font-bold">
																		{split[0]}
																		{split[1] && (
																			<span className="text-[#c9c9c9] text-xs font-bold">
																				{split[1]}
																			</span>
																		)}
																	</p>
																</li>
															);
														})}
														<span
															style={{
																textTransform: "uppercase",
																fontSize: "1.5rem",
																fontWeight: "800",
																color: "white",
																backgroundColor: "#30B151",
																borderRadius: "20px",
																padding: "0.5rem 1rem",
																display: "flex",
																justifyContent: "center",
																alignItems: "center",
															}}
														>
															$30/mo DISCOUNT <br />
															FOR 36 MONTHS
														</span>
														<h1 className="text-4xl font-[500] m-4 text-center text-black">
															-OR-
														</h1>
														<span
															style={{
																textTransform: "uppercase",
																fontSize: "1.5rem",
																fontWeight: "800",
																color: "white",
																backgroundColor: "#483092",
																borderRadius: "20px",
																padding: "0.5rem 1rem",
																display: "flex",
																justifyContent: "center",
																alignItems: "center",
															}}
														>
															A $400
															<br />
															GIFT CARD
														</span>
														{neverPromo.map((item, index) => {
															if (index <= 5) {
																return <></>;
															}
															const split = item.split(";");
															return (
																<li
																	className="flex items-center justify-start "
																	key={index}
																>
																	<div className="w-10">
																		<FaCheckCircle
																			color={"#3AB54A"}
																			size={25}
																		/>
																	</div>
																	<p className="text-black text-left font-bold">
																		{split[0]}
																		{split[1] && (
																			<span className="text-black text-left font-bold flex-wrap">
																				<br />
																				{split[1]}
																			</span>
																		)}
																		{split[2] && (
																			<span className="text-black text-left font-bold flex-wrap">
																				<br />
																				{split[2]}
																			</span>
																		)}
																	</p>
																</li>
															);
														})}
													</>
												) : (
													hfcNotNeverPromo.map((item, index) => {
														const split = item.split(";");
														return (
															<li
																className="flex items-center justify-start "
																key={index}
															>
																<div className="w-20">
																	<FaCheckCircle color={"#3AB54A"} size={25} />
																</div>
																<p className="text-black text-left font-bold flex-wrap">
																	{split[0]}
																	{split[1] && (
																		<span className="text-black text-left font-bold flex-wrap">
																			<br />
																			{split[1]}
																		</span>
																	)}
																	{split[2] && (
																		<span className="text-black text-left font-bold flex-wrap">
																			<br />
																			{split[2]}
																		</span>
																	)}
																</p>
															</li>
														);
													})
												)
											) : offer?.neverPromo ? (
												<>
													{" "}
													{neverPromo.map((item, index) => {
														if (index > 5) {
															return <></>;
														}
														const split = item.split(";");
														return (
															<li
																className="flex items-center justify-start "
																key={index}
															>
																<div className="w-10">
																	<FaCheckCircle color={"#3AB54A"} size={25} />
																</div>
																<p className="text-black text-left font-bold">
																	{split[0]}
																	{split[1] && (
																		<span className="text-[#c9c9c9] text-xs font-bold">
																			{split[1]}
																		</span>
																	)}
																</p>
															</li>
														);
													})}
													<span
														style={{
															textTransform: "uppercase",
															fontSize: "1.5rem",
															fontWeight: "800",
															color: "white",
															backgroundColor: "#30B151",
															borderRadius: "20px",
															padding: "0.5rem 1rem",
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														$30/mo DISCOUNT <br />
														FOR 36 MONTHS
													</span>
													<h1 className="text-4xl font-[500] m-4 text-center text-black">
														-OR-
													</h1>
													<span
														style={{
															textTransform: "uppercase",
															fontSize: "1.5rem",
															fontWeight: "800",
															color: "white",
															backgroundColor: "#483092",
															borderRadius: "20px",
															padding: "0.5rem 1rem",
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														A $400
														<br />
														GIFT CARD
													</span>
													{neverPromo.map((item, index) => {
														if (index <= 5) {
															return <></>;
														}
														const split = item.split(";");
														return (
															<li
																className="flex items-center justify-start "
																key={index}
															>
																<div className="w-10">
																	<FaCheckCircle color={"#3AB54A"} size={25} />
																</div>
																<p className="text-black text-left font-bold">
																	{split[0]}
																	{split[1] && (
																		<span className="text-black text-left font-bold flex-wrap">
																			<br />
																			{split[1]}
																		</span>
																	)}
																	{split[2] && (
																		<span className="text-black text-left font-bold flex-wrap">
																			<br />
																			{split[2]}
																		</span>
																	)}
																</p>
															</li>
														);
													})}
												</>
											) : (
												notNeverPromo.map((item, index) => {
													const split = item.split(";");
													return (
														<li
															className="flex items-center justify-start "
															key={index}
														>
															<div className="w-20">
																<FaCheckCircle color={"#3AB54A"} size={25} />
															</div>
															<p className="text-black text-left font-bold flex-wrap">
																{split[0]}
																{split[1] && (
																	<span className="text-black text-left font-bold flex-wrap">
																		<br />
																		{split[1]}
																	</span>
																)}
																{split[2] && (
																	<span className="text-black text-left font-bold flex-wrap">
																		<br />
																		{split[2]}
																	</span>
																)}
															</p>
														</li>
													);
												})
											)}
											{/* {offer?.offerTemplate?.bulletPoints
												.split("\n")
												.map((bulletPoint, index) => {
													if (
														bulletPoint === "Symmetrical Speeds^^" &&
														offer?.lead?.leadType === "HFC"
													) {
														return (
															<li
																className="flex items-center justify-start "
																key={index}
															>
																<div className="w-10">
																	<FaCheckCircle color={"#3AB54A"} size={25} />
																</div>
																<p className="text-black font-bold">
																	24/7 Local Support
																</p>
															</li>
														);
													}

													if (
														bulletPoint === "Router & Modem Only $10/MO!" &&
														offer.neverPromo
													) {
														return <></>;
													}

													return (
														<li
															className="flex items-center justify-start "
															key={index}
														>
															<div className="w-10">
																<FaCheckCircle color={"#3AB54A"} size={25} />
															</div>
															<p className="text-black text-left font-bold">
																{bulletPoint}
															</p>
														</li>
													);
												})} */}
										</ul>

										<img
											style={{ width: "250px" }}
											src={"data:image/png;base64," + offer?.fiberCompany?.logo}
											alt="logo"
											className="logo"
										/>
									</div>
								</div>
							)}
							<div className="company_details m-10 flex items-center justify-center ">
								{offer?.lead?.leadType === "HFC" ? (
									offer?.neverPromo ? (
										<div>
											<h1 className="text-black text-5xl font-bold text-center">
												EXCLUSIVE TO <br />
												"NEVER" HFC
												<br />
												CUSTOMERS
											</h1>
											<p className="max-w-lg flex flex-wrap text-xl text-center font-semibold p-10 text-black">
												Our Hybrid Fiber-Coaxial Network EXCLUSIVE TO “NEVER”
												HFC CUSTOMERS combines fiber-optic power with coaxial
												reliability, giving your home high-speed internet over
												trusted infrastructure.
											</p>
										</div>
									) : (
										<li className="flex items-center justify-center flex-wrap">
											<p className="text-[#2761D0] text-xl text-left font-bold underline">
												Terms & conditions may apply
											</p>
											<div>
												<h1 className="text-black text-5xl mt-6 font-bold text-center">
													ABOUT HFC
													<br />
													TECHNOLOGY
												</h1>
												<p className="max-w-lg flex flex-wrap text-xl text-center font-semibold p-10 text-black">
													Enjoy next-level speed and performance through our
													Hybrid Fiber-Coaxial (HFC) network – an advanced blend
													of fiber optics and coaxial cable delivering
													blazing-fast internet directly to your home.
												</p>
											</div>
										</li>
									)
								) : offer?.neverPromo ? (
									<div>
										<h1 className="text-black text-5xl font-bold text-center">
											EXCLUSIVE TO <br />
											"NEVER"
											<br />
											CUSTOMERS
										</h1>
										<p className="max-w-lg flex flex-wrap text-xl text-center font-semibold p-10 text-black">
											This offer is only available to homes that have never had
											Astound service (or any of its predecessors). If that’s
											you — you qualify for our most aggressive savings ever.
										</p>
									</div>
								) : (
									<li className="flex items-center justify-center flex-wrap">
										<p className="text-[#2761D0] text-xl text-left font-bold underline">
											Terms & conditions may apply
										</p>
									</li>
								)}
							</div>
						</div>
					)}

					<div
						// style={{
						// 	marginTop: "-6rem",
						// }}
						className="banner"
					>
						<img
							style={{ width: "100%", height: "auto" }}
							src="/images/offer/astound/smiling_customer.png"
							alt="banner"
							className="banner_image"
						/>
						<div
							style={{
								marginTop: "-4rem",
								width: "100%",
								backgroundColor: "white",
								padding: "2rem 0rem",
							}}
						>
							<button
								style={{
									backgroundColor: "#483092",
								}}
								onClick={() => setOpenConsultation(true)}
								className=" schedule_button"
							>
								Schedule A<br />
								Consultation
							</button>
							<h1 className="customer_service">
								Great Customer
								<br />
								Service is Built In.
							</h1>
							<p className="customer_service_p font-semibold">
								We understand the importance
								<br /> of the services we provide to <br />
								your home – that’s why we
								<br />
								treat you like family.
							</p>
						</div>
					</div>
					{/* <div className=' banner'> */}
					{/* <div className='flex justify-center items-center flex-col p-4 gap-4' style={{ marginTop: "-4rem", width: "100%", backgroundColor: "black", padding: "2rem 0rem" }}>
                            <p className='text-5xl font-extrabold text-[#F47920]'>GIVE $100</p>
                            <p className='text-5xl font-extrabold'>GET $100</p>
                            <p className='text-lg text-center'>Give your friends a $100 gift card when they use your unique link to sign up for Point Broadband service online, and you'll get a $100 gift card*, too, after their service is installed.</p>
                            <p className="text-3xl text-center font-bold">GET $100 FOR EVERY<br />FRIEND YOU REFER</p>
                        </div> */}

					{/* </div> */}
					<div
						style={
							{
								// marginTop: "-8rem"
							}
						}
						className="banner"
					>
						{/* <button
              onClick={() => {
                // createSharedOffer()
                setOpenShareModal(true);
              }}
              style={{ backgroundColor: "#F47920" }}
              className="schedule_button"
            >
              Share Offer
            </button> */}
						<img
							style={{ marginTop: "-3rem", width: "100%", height: "auto" }}
							src="/images/offer/astound/woman.png"
							alt="banner"
							className="banner_image"
						/>
					</div>
					<div
						style={{
							marginTop: "-14rem",
							border: "4px solid #3AB54A",
						}}
						className=" offer_services_container"
					>
						<div className="min-w-[350px] text-black inner_container">
							<h1>
								FIBER INTERNET,
								<br />
								MOBILE & TV
							</h1>
							<div className="services">
								<IoWifi color="#483092" size={100} />
								<h3>Internet</h3>
								<p
									style={{
										color: "#483092",
									}}
								>
									See Plans
								</p>
							</div>
							<div className="services">
								<IoMdTv color="#483092" size={100} />
								<h3>TV</h3>
								<p
									style={{
										color: "black",
									}}
								>
									Start Streaming now
								</p>
							</div>
							<div className="services">
								<FaPhone color="#483092" size={100} />
								<h3>Mobile Plan</h3>
								<p
									style={{
										color: "black",
									}}
								>
									Talk More. Pay Less
								</p>
							</div>
						</div>
					</div>
					<div className="banner">
						<div
							style={{
								backgroundColor: "white",
								borderRadius: "20px",
								borderTopLeftRadius: "0px",
								marginTop: "2rem",
								borderTopRightRadius: "0px",
								padding: "2rem",
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							{/* <h1 className="quick_h1">Quick Links</h1> */}
							<img
								style={{ margin: "1rem 0rem" }}
								src={`/images/offer/astound/astound_phone.png`}
								alt="astound"
								className="company_logo"
							/>
							<h3 className="quick_h3">Contact</h3>
							<p className="quick_p">Lightning Support</p>
							<p
								onClick={() => {
									let contactButton = new ContactButtons();
									contactButton.call("+13464835900");
								}}
								className="quick_h3 sm:quick_h1 cursor-pointer underline"
							>
								+1 346-483-5900
							</p>
							<p className="quick_p">Austin, TX, USA</p>
							<img
								style={{ margin: "1rem 0rem" }}
								src={`/images/offer/astound/logo.png`}
								alt="fastwyre"
								className="company_logo"
							/>
							<img
								style={{ margin: "1rem 0rem" }}
								src="/images/offer/logo.png"
								alt="lightning"
								className="company_logo"
							/>
							<p className="quick_copy">
								Copyright Lightning OS 2024. All rights reserved.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Index;
